import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader, EmptyState, StatusPill } from "@/components/common";
import { Button } from "@/components/ui/button";
import { useApi } from "@/lib/api";
import { timeAgo } from "@/lib/labels";

export default function MyApplications() {
  const api = useApi();
  const [apps, setApps] = useState(null);
  useEffect(() => { api("get", "/applications/mine").then(setApps); }, [api]);
  return (
    <div className="max-w-4xl">
      <p className="eyebrow">Your applications</p>
      <h1 className="mt-2 text-3xl font-extrabold tracking-tight">My applications</h1>
      <div className="mt-8">
        {apps === null ? <Loader /> : apps.length === 0 ? (
          <EmptyState testId="applications-empty" title="No applications yet" text="Browse jobs and apply with one click."
            action={<Button asChild data-testid="applications-browse-jobs"><Link to="/jobs">Browse jobs</Link></Button>} />
        ) : (
          <div className="panel divide-y divide-slate-100">
            {apps.map((a) => (
              <Link key={a.id} to={`/jobs/${a.job_id}`} data-testid={`application-row-${a.id}`} className="p-5 flex flex-wrap items-center justify-between gap-3 hover:bg-slate-50 transition-colors">
                <div>
                  <p className="eyebrow">{a.company_name}</p>
                  <p className="mt-1 font-bold">{a.job_title}</p>
                  <p className="font-mono text-[11px] text-slate-400 mt-1">Sent {timeAgo(a.created_at)}</p>
                </div>
                <StatusPill status={a.status} testId={`application-status-${a.id}`} />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
